import React, { useRef, useState } from 'react'
import { THEMES } from '../../constatnts'
import { Collapse, Button as MuiButton, TextField } from '@mui/material'
import { styled } from '@mui/material/styles'

import './home.css'
import Spacer from 'src/components/Spacer'
import { Form } from './form'
import Divider from 'src/components/Divider'
import { NavigationSpecial } from 'src/components/navigation-special/nav'
import { FooterSpecial } from 'src/components/footer-special/footer'
import { useNavigate } from 'react-router-dom'

export const StarsListMarker = () => {
  return (
    <svg
      style={{ marginRight: 10 }}
      width='19'
      height='20'
      viewBox='0 0 19 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.54242 8.59028L10.2802 12.0988C10.2893 12.117 10.304 12.1318 10.3222 12.1409L13.8447 13.9129C13.9135 13.9475 13.9137 14.0457 13.845 14.0805L10.3216 15.8645C10.3038 15.8736 10.2893 15.8881 10.2803 15.906L8.52052 19.393C8.48575 19.4619 8.38729 19.4617 8.35279 19.3927L6.61017 15.9057C6.60133 15.888 6.58712 15.8735 6.56958 15.8644L3.10308 14.0584C3.03528 14.0231 3.03589 13.9259 3.10412 13.8914L6.56894 12.1408C6.58688 12.1317 6.60144 12.1172 6.61047 12.0992L8.37447 8.58979C8.40924 8.52063 8.50807 8.52092 8.54242 8.59028Z'
        fill='#0174BB'
      />
      <path
        d='M15.3873 4.18431L16.5186 6.46836C16.5245 6.48023 16.5341 6.48987 16.5459 6.49582L18.8392 7.64941C18.884 7.67194 18.884 7.73585 18.8393 7.7585L16.5456 8.91991C16.534 8.9258 16.5245 8.93525 16.5186 8.94689L15.373 11.217C15.3504 11.2618 15.2863 11.2617 15.2638 11.2168L14.1294 8.94669C14.1236 8.93518 14.1144 8.92577 14.103 8.91982L11.8462 7.74411C11.8021 7.72111 11.8025 7.65783 11.8469 7.63539L14.1025 6.49574C14.1142 6.48984 14.1237 6.48034 14.1296 6.46865L15.278 4.18399C15.3006 4.13896 15.3649 4.13915 15.3873 4.18431Z'
        fill='#0174BB'
      />
      <path
        d='M4.44675 0.634443L5.57807 2.91849C5.58395 2.93037 5.59353 2.94 5.60537 2.94596L7.89861 4.09954C7.9434 4.12207 7.94348 4.18598 7.89875 4.20863L5.60504 5.37004C5.59341 5.37593 5.58396 5.38539 5.57809 5.39703L4.43249 7.6671C4.40985 7.71196 4.34575 7.71184 4.32329 7.66689L3.18883 5.39683C3.18307 5.38531 3.17383 5.37591 3.16241 5.36996L0.905679 4.19424C0.861547 4.17125 0.861941 4.10796 0.906356 4.08552L3.16199 2.94587C3.17367 2.93997 3.18315 2.93047 3.18902 2.91878L4.33741 0.634122C4.36004 0.589097 4.42438 0.589286 4.44675 0.634443Z'
        fill='#0174BB'
      />
    </svg>
  )
}

export const Input = styled(TextField)(() => ({
  fontFamily: 'Source Sans 3',
  marginRight: '10px',
  '& .MuiOutlinedInput-root': {
    borderRadius: 0,
    background: '#F9F7F7',
    height: '65px'
  }
}))
export const Button = styled(MuiButton)(() => ({
  fontFamily: 'Source Sans 3',
  backgroundColor: '#0075BC',
  borderRadius: 0,
  height: '72px',
  '&:hover': {
    backgroundColor: '#3e7099'
  }
}))

export const SpecialOffer = ({ loc = 'uk' }) => {
  const [selectedFaq, setSelectedFaq] = useState(0)
  const isMobile = window.innerWidth < 768

  const navigate = useNavigate()

  return (
    <div className='special-offer-page'>
      <NavigationSpecial theme={THEMES.dark} />
      <section className='main white'>
        <div className='container'>
          <div className='row row-center mb70 mob-mb-20 mob-column'>
            <div className='column main-left mob-fw'>
              <h1 className='lh11 mob-lh-12 mob-mb-30 '>Gallagher Security Awareness</h1>
              <p style={{ wordSpacing: 3, color: '#5D5D5D' }} className='fs20 mob-fs-18 mb40 mob-mb-50 lh16'>
                Empower your employees with latest security training, videos and attack simulations.
              </p>
              <div className='row'>
                <StarsListMarker />
                <p className='fs18 fw700 blue-text lh14 mb10' style={{}}>
                  200+ training modules & 70+ engaging videos
                </p>
              </div>
              <div className='row'>
                <StarsListMarker />
                <p className='fs18 fw700 blue-text lh14 mb10' style={{}}>
                  Gamified learning platform
                </p>
              </div>
              <div className='row'>
                <StarsListMarker />
                <p className='fs18 fw700 blue-text lh14 mb10' style={{}}>
                  500+ Automated phishing tests & training
                </p>
              </div>
              <div className='row'>
                <StarsListMarker />
                <p className='fs18 fw700 blue-text lh14 mb10' style={{}}>
                  No integration required — start training in 5 minutes
                </p>
              </div>
              <div className='row'>
                <StarsListMarker />
                <p className='fs18 fw700 blue-text lh14 mb10' style={{}}>
                  Always up-to-date content — free monthly updates
                </p>
              </div>
            </div>
            <Spacer />
            <div className='main-right mob-fw mob-hide'>
              <img src='/images/gr32.png' className='home-main-img' alt='' />
            </div>
          </div>
          {loc == 'uk' && (
            <p className='fs24 mb20' style={{ color: '#5D5D5D' }}>
              All features for <span className='fw700'>£1188 + VAT per annum</span>, the equivalent of just{' '}
              <span className='fw700'>£99 + VAT per month</span>.
            </p>
          )}
          {loc == 'us' && (
            <p className='fs24 mb20' style={{ color: '#5D5D5D' }}>
              All features for <span className='fw700'>5000 USD + Local Tax per annum</span>, the equivalent of just{' '}
              <span className='fw700'>417 USD + Local Tax per month</span>.
            </p>
          )}
          {loc == 'eu' && (
            <p className='fs24 mb20' style={{ color: '#5D5D5D' }}>
              All features for <span className='fw700'> €1,500 + VAT per annum</span>, the equivalent of just{' '}
              <span className='fw700'>€125 + VAT per month</span>.
            </p>
          )}
          {loc == 'aus' && (
            <p className='fs24 mb20' style={{ color: '#5D5D5D' }}>
              All features for <span className='fw700'>A$2600 + GST per annum</span>, the equivalent of just{' '}
              <span className='fw700'>A$216.66 + GST per month</span>.
            </p>
          )}
          <p className='mb30' style={{ color: '#5D5D5D' }}>
            This pricing applies to companies with up to 400 employees. For organizations exceeding this size, a
            tailored and competitively priced offer is available upon request.
          </p>
          <Form loc={loc} advancedMobile={true} advanced={false} />
          <div className='main-right mob-fw hide mob-show'>
            <img src='/images/gr32.png' className='home-main-img' alt='' />
          </div>
        </div>
      </section>
      <section className='light pt100 pb130 mob-light mob-pt-60 mob-pb-70'>
        <div className='container column column-center'>
          <h2 className='text-center fs40 lh14 mob-fs-26' style={{ marginBottom: 85 }}>
            Phishing remains the <br className='hide mob-show' />
            <br className='hide mob-show' />
            <span className='blue-text fw600'>#1 threat vector</span>
          </h2>
          {/* <IncidentsScema /> */}
          <div style={{ gap: 20, width: '100%' }} className='row mob-column'>
            <div
              className='column border shadow one-of-3 mob-fw'
              style={{ borderRadius: 0, padding: isMobile ? '20px  30px 30px' : '40px 43px 34px' }}
            >
              <div className='column mob-row-reverse'>
                <svg
                  style={{ marginBottom: isMobile ? 0 : 32, marginTop: isMobile ? 13 : 0 }}
                  width='91'
                  height='17'
                  viewBox='0 0 91 17'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M85.8003 14.5864C85.8003 13.2766 86.8694 12.2139 88.1856 12.2139C89.5025 12.2139 90.5704 13.2766 90.5704 14.5864C90.5704 15.8962 89.5025 16.9582 88.1856 16.9582C86.8694 16.9582 85.8003 15.8962 85.8003 14.5864Z'
                    fill='#52AF00'
                  />
                  <path
                    d='M9.72544 8.30232C9.72544 6.7996 9.43351 5.68474 8.84958 4.95844C8.26494 4.23282 7.37933 3.87035 6.18873 3.87035H4.9222V13.0597H5.89121C7.21367 13.0597 8.18278 12.6698 8.79984 11.8872C9.41618 11.106 9.72544 9.91077 9.72544 8.30232ZM14.2422 8.14582C14.2422 10.8835 13.5023 12.9931 12.0224 14.4739C10.5426 15.9553 8.46233 16.696 5.7808 16.696H0.570312V0.291016H6.14451C8.73008 0.291016 10.7262 0.964456 12.1328 2.31066C13.5389 3.65755 14.2422 5.60169 14.2422 8.14582Z'
                    fill='#8792AC'
                  />
                  <path d='M28.6753 16.6963H32.8215V0.222656H28.6753V16.6963Z' fill='#8792AC' />
                  <path
                    d='M38.6464 10.5513C38.6464 11.6017 38.7844 12.4028 39.0598 12.9533C39.3359 13.5046 39.7983 13.7799 40.4485 13.7799C41.0918 13.7799 41.5466 13.5046 41.8117 12.9533C42.0767 12.4028 42.2086 11.6017 42.2086 10.5513C42.2086 9.50649 42.0746 8.71838 41.8062 8.18635C41.537 7.65295 41.0781 7.3859 40.4272 7.3859C39.7908 7.3859 39.3359 7.65159 39.0598 8.18019C38.7844 8.70947 38.6464 9.49962 38.6464 10.5513ZM46.4286 10.5513C46.4286 12.5524 45.9012 14.1135 44.8438 15.2325C43.7871 16.3522 42.308 16.9123 40.4064 16.9123C38.5829 16.9123 37.1313 16.3398 36.0539 15.1947C34.9751 14.0496 34.436 12.5023 34.436 10.5513C34.436 8.55639 34.9641 7.00628 36.0215 5.90103C37.0789 4.79578 38.5615 4.24316 40.4706 4.24316C41.6502 4.24316 42.6938 4.49924 43.598 5.01067C44.5029 5.52211 45.2014 6.25459 45.6922 7.20881C46.1836 8.16166 46.4286 9.27651 46.4286 10.5513Z'
                    fill='#8792AC'
                  />
                  <path d='M48.0742 16.6966H52.2211V10.3919V4.45996H48.0742V16.6966Z' fill='#8792AC' />
                  <path d='M48.0742 2.9793H52.2211V0.22168H48.0742V2.9793Z' fill='#8792AC' />
                  <path
                    d='M60.6224 13.5756C61.1822 13.5756 61.8489 13.4342 62.6268 13.1534V16.2323C62.0677 16.4767 61.5363 16.6517 61.031 16.7554C60.5258 16.8604 59.9328 16.9126 59.2544 16.9126C57.8622 16.9126 56.8586 16.5646 56.2422 15.8698C55.6286 15.1751 55.3208 14.1083 55.3208 12.6687V7.62442H53.8687V4.46107H55.3208V1.33617L59.4995 0.613281V4.46107H62.1451V7.62442H59.4995V12.3873C59.4995 13.1795 59.8742 13.5756 60.6224 13.5756Z'
                    fill='#8792AC'
                  />
                  <path
                    d='M70.2203 13.5756C70.7801 13.5756 71.4469 13.4342 72.2247 13.1534V16.2323C71.6664 16.4767 71.1341 16.6517 70.6289 16.7554C70.123 16.8604 69.5321 16.9126 68.8522 16.9126C67.4601 16.9126 66.4566 16.5646 65.8416 15.8698C65.2266 15.1751 64.9188 14.1083 64.9188 12.6687V7.62442H63.4658V4.46107H64.9188V1.28881L69.0966 0.613281V4.46107H71.7436V7.62442H69.0966V12.3873C69.0966 13.1795 69.4714 13.5756 70.2203 13.5756Z'
                    fill='#8792AC'
                  />
                  <path
                    d='M77.4569 9.06025C77.5135 8.39024 77.7062 7.8994 78.0347 7.58568C78.3647 7.27264 78.7719 7.11613 79.2592 7.11613C79.7907 7.11613 80.213 7.29185 80.5264 7.64608C80.8418 7.99825 81.0061 8.46987 81.0193 9.06025H77.4569ZM83.3045 5.6855C82.3189 4.72441 80.9205 4.24316 79.1114 4.24316C77.2099 4.24316 75.7467 4.79578 74.721 5.90103C73.696 7.00628 73.1831 8.59209 73.1831 10.6584C73.1831 12.6595 73.7374 14.2027 74.8431 15.286C75.9495 16.3693 77.5032 16.9116 79.5041 16.9116C80.4649 16.9116 81.2919 16.8464 81.9849 16.7167C82.6737 16.5883 83.3404 16.3563 83.9872 16.0212L83.3501 13.2636C82.8801 13.4545 82.4328 13.6014 82.0104 13.6982C81.4002 13.8389 80.7308 13.9096 80.0019 13.9096C79.2026 13.9096 78.5717 13.7153 78.1093 13.3268C77.6468 12.9375 77.4004 12.4007 77.3721 11.717H84.7837V9.83805C84.7837 8.03052 84.2908 6.64589 83.3045 5.6855Z'
                    fill='#8792AC'
                  />
                  <path
                    d='M19.745 9.06025C19.8016 8.39024 19.9942 7.8994 20.3227 7.58568C20.6519 7.27264 21.0599 7.11613 21.548 7.11613C22.078 7.11613 22.5004 7.29185 22.8145 7.64608C23.1299 7.99825 23.2935 8.46987 23.308 9.06025H19.745ZM25.5933 5.6855C24.607 4.72441 23.2092 4.24316 21.3995 4.24316C19.4972 4.24316 18.0346 4.79578 17.0096 5.90103C15.9847 7.00628 15.4712 8.59209 15.4712 10.6584C15.4712 12.6595 16.0248 14.2027 17.1319 15.286C18.2376 16.3693 19.7913 16.9116 21.7922 16.9116C22.753 16.9116 23.5799 16.8464 24.2728 16.7167C24.9617 16.5883 25.6285 16.3563 26.276 16.0212L25.6382 13.2636C25.1681 13.4545 24.7208 13.6014 24.2991 13.6982C23.6876 13.8389 23.0187 13.9096 22.2898 13.9096C21.4913 13.9096 20.8598 13.7153 20.3974 13.3268C19.9342 12.9375 19.6885 12.4007 19.6602 11.717H27.0717V9.83805C27.0717 8.03052 26.5789 6.64589 25.5933 5.6855Z'
                    fill='#8792AC'
                  />
                </svg>
                <Spacer />
                <p className='big-num neutral-text lh14 fw700'>91%</p>
              </div>
              <p className='grey-text fs16 mb30' style={{ lineHeight: '150%' }}>
                of all attacks begin with phishing.
              </p>
              <Spacer />
              <Divider style={{ marginTop: 0, marginBottom: 20 }} />
              <p className='grey-text fs16 ' style={{ lineHeight: '150%' }}>
                Global Future of Cyber Survey
              </p>
            </div>
            <div
              className='column border shadow one-of-3  mob-fw'
              style={{ borderRadius: 0, padding: isMobile ? '20px  30px 30px' : '40px 43px 34px' }}
            >
              <div className='column mob-row-reverse'>
                <svg
                  style={{ marginBottom: isMobile ? 0 : 32, marginTop: isMobile ? 13 : 0 }}
                  width='45'
                  height='19'
                  viewBox='0 0 45 19'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path d='M0.000976562 17.3584H8.7505V18.6109H0.000976562V17.3584Z' fill='#4379FF' />
                  <path d='M0.000976562 14.9551H8.7505V16.212H0.000976562V14.9551Z' fill='#4379FF' />
                  <path d='M2.49756 12.5566H6.25053V13.8136H2.49756V12.5566Z' fill='#4379FF' />
                  <path d='M2.49756 10.1582H6.25053V11.4151H2.49756V10.1582Z' fill='#4379FF' />
                  <path d='M2.49756 7.76074H6.25053V9.01769H2.49756V7.76074Z' fill='#4379FF' />
                  <path d='M2.49756 5.3584H6.25053V6.61534H2.49756V5.3584Z' fill='#4379FF' />
                  <path d='M8.7505 2.95996H0.000976562V4.21691H8.7505V2.95996Z' fill='#4379FF' />
                  <path d='M8.7505 0.5625H0.000976562V1.81945H8.7505V0.5625Z' fill='#4379FF' />
                  <path
                    d='M9.99854 16.212H23.4549C23.6822 15.8243 23.8516 15.4008 23.9541 14.9551H9.99854V16.212Z'
                    fill='#4379FF'
                  />
                  <path
                    d='M22.4074 10.1582H12.499V11.4151H23.4549C23.1696 10.9337 22.8175 10.5103 22.4074 10.1582Z'
                    fill='#4379FF'
                  />
                  <path
                    d='M12.499 7.76074V9.01769H22.4074C22.8264 8.66556 23.1785 8.24211 23.4549 7.76074H12.499Z'
                    fill='#4379FF'
                  />
                  <path
                    d='M23.4549 2.95996H9.99854V4.21691H23.9541C23.8383 3.77118 23.6689 3.34777 23.4549 2.95996Z'
                    fill='#4379FF'
                  />
                  <path
                    d='M19.3186 0.5625H9.99854V1.81945H22.5323C21.6943 1.04387 20.5577 0.5625 19.3186 0.5625Z'
                    fill='#4379FF'
                  />
                  <path d='M16.2475 5.3584H12.499V6.61534H16.2475V5.3584Z' fill='#4379FF' />
                  <path
                    d='M20.0005 6.61534H23.9228C24.0343 6.21421 24.0922 5.79076 24.0922 5.3584H20.0005V6.61534Z'
                    fill='#4379FF'
                  />
                  <path d='M12.499 12.5566H16.2475V13.8136H12.499V12.5566Z' fill='#4379FF' />
                  <path
                    d='M20.0005 12.5566V13.8136H24.0922C24.0922 13.3812 24.0343 12.9578 23.9228 12.5566H20.0005Z'
                    fill='#4379FF'
                  />
                  <path
                    d='M9.99854 18.602L19.3186 18.6153C20.5666 18.6153 21.6943 18.134 22.5367 17.3584H9.99854V18.602Z'
                    fill='#4379FF'
                  />
                  <path d='M25.0015 17.3584H31.2505V18.6109H25.0015V17.3584Z' fill='#4379FF' />
                  <path d='M25.0015 14.9551H31.2505V16.212H25.0015V14.9551Z' fill='#4379FF' />
                  <path d='M27.4971 12.5566H31.25V13.8136H27.4971V12.5566Z' fill='#4379FF' />
                  <path d='M27.4971 10.1582H31.25V11.4151H27.4971V10.1582Z' fill='#4379FF' />
                  <path d='M32.9888 2.95996H25.0015V4.21691H33.4211L32.9888 2.95996Z' fill='#4379FF' />
                  <path d='M32.1597 0.5625H25.0015V1.81945H32.5921L32.1597 0.5625Z' fill='#4379FF' />
                  <path d='M38.7471 17.3584H45.0006V18.6109H38.7471V17.3584Z' fill='#4379FF' />
                  <path d='M38.7471 14.9551H45.0006V16.212H38.7471V14.9551Z' fill='#4379FF' />
                  <path d='M38.7471 12.5566H42.5V13.8136H38.7471V12.5566Z' fill='#4379FF' />
                  <path d='M38.7471 10.1582H42.5V11.4151H38.7471V10.1582Z' fill='#4379FF' />
                  <path
                    d='M38.7471 9.01769H42.5001V7.76074H38.7471H35.3507L34.9986 8.77703L34.6465 7.76074H31.25H27.4971V9.01769H31.25V7.86325L31.6468 9.01769H38.3504L38.7471 7.86325V9.01769Z'
                    fill='#4379FF'
                  />
                  <path d='M42.5002 5.3584H36.1799L35.7476 6.61534H42.5002V5.3584Z' fill='#4379FF' />
                  <path d='M37.8425 0.5625L37.4102 1.81945H45.0008V0.5625H37.8425Z' fill='#4379FF' />
                  <path d='M34.9988 18.602L35.4311 17.3584H34.5664L34.9988 18.602Z' fill='#4379FF' />
                  <path d='M34.1698 16.212H35.8279L36.2736 14.9551H33.7285L34.1698 16.212Z' fill='#4379FF' />
                  <path d='M33.3275 13.8136H36.6704L37.1117 12.5567L32.8862 12.5566L33.3275 13.8136Z' fill='#4379FF' />
                  <path d='M32.4895 11.4151H37.5128L37.9407 10.1582H32.0571L32.4895 11.4151Z' fill='#4379FF' />
                  <path d='M27.4971 6.61534H34.2498L33.8174 5.3584H27.4971V6.61534Z' fill='#4379FF' />
                  <path d='M36.5811 4.21691H45.0008V2.95996H37.009L36.5811 4.21691Z' fill='#4379FF' />
                </svg>
                <Spacer />
                <p className='big-num neutral-text lh14 fw700'>3X</p>
              </div>
              <p className='grey-text fs16 mb30' style={{ lineHeight: '150%' }}>
                click effectiveness for targeted phishing campaigns that add phone calls.
              </p>
              <Spacer />
              <Divider style={{ marginTop: 0, marginBottom: 20 }} />
              <p className='grey-text fs16 ' style={{ lineHeight: '150%' }}>
                IBM Security X-Force Threat Intelligence
              </p>
            </div>
            <div
              className='column border shadow one-of-3  mob-fw'
              style={{ borderRadius: 0, padding: isMobile ? '20px  30px 30px' : '40px 43px 34px' }}
            >
              <div className='column mob-row-reverse'>
                <svg
                  style={{ marginBottom: isMobile ? 0 : 32, marginTop: isMobile ? 13 : 0 }}
                  width='91'
                  height='25'
                  viewBox='0 0 91 25'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <mask id='mask0_545_1210' maskUnits='userSpaceOnUse' x='0' y='0' width='91' height='25'>
                    <path d='M90.5317 0.941406H0.531738V24.2403H90.5317V0.941406Z' fill='white' />
                  </mask>
                  <g mask='url(#mask0_545_1210)'>
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M8.67647 13.5103H5.37751L7.13014 7.80933L8.67647 13.5103ZM3.83118 19.2732L4.86212 15.799H9.08878L10.1197 19.2732H13.625L9.91356 6.08771C9.7074 5.22173 9.29509 4.94336 8.36723 4.94336H3.21256V6.12891H3.62503C4.2435 6.12891 4.55273 6.32473 4.55273 6.79907C4.55273 7.09797 4.55273 7.29394 4.2435 8.00515L0.532227 19.2732'
                      fill='#002E83'
                    />
                    <path
                      d='M18.0574 19.2732V5.99497C18.0574 5.30413 17.645 4.94336 16.9234 4.94336H13.7275V6.12891H13.9337C14.5522 6.12891 14.8616 6.38661 14.8616 6.94335V19.2732'
                      fill='#002E83'
                    />
                    <path
                      d='M23.8309 19.2732V5.99497C23.8309 5.30413 23.4184 4.94336 22.6969 4.94336H19.501V6.12891H19.7071C20.3258 6.12891 20.635 6.38661 20.635 6.94335V19.2732'
                      fill='#002E83'
                    />
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M29.7068 6.21133C29.7068 5.2628 28.9851 4.70605 27.8511 4.70605C26.614 4.70605 25.9956 5.2628 25.9956 6.21133C25.9956 7.18039 26.614 7.74732 27.8511 7.74732C28.9851 7.74732 29.7068 7.18039 29.7068 6.21133ZM29.6038 19.2731V9.60303C29.6038 8.93287 29.1915 8.54108 28.5728 8.54108H25.377V9.70611H25.5831C26.2017 9.70611 26.4079 9.96381 26.4079 10.5514V19.2731'
                      fill='#002E83'
                    />
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M37.2328 14.0665V16.211C36.6142 16.8294 35.8926 17.18 35.274 17.18C34.6554 17.18 34.3462 16.881 34.3462 16.0769C34.3462 15.1902 34.5523 14.8501 35.274 14.5718C35.7894 14.3553 36.305 14.2212 37.2328 14.0665ZM32.6968 11.4996L33.006 11.3759C33.8308 11.046 34.3462 10.9222 34.9648 10.8088C35.274 10.7676 35.6863 10.7264 35.8926 10.7264C36.9234 10.7264 37.2328 11.0666 37.2328 12.015V12.2831C35.7894 12.5202 35.3771 12.6026 34.5523 12.7779C34.14 12.881 33.7277 13.0151 33.3152 13.1902C31.9751 13.7263 31.3564 14.7572 31.3564 16.3758C31.3564 18.4068 32.1812 19.3758 34.0369 19.3758C34.7586 19.3758 35.4802 19.2109 35.9957 18.881C36.5111 18.644 36.7173 18.5202 37.3359 17.9531V18.283C37.3359 18.9532 37.6451 19.2728 38.2637 19.2728H41.3564V18.1696H41.2533C40.6348 18.1696 40.3256 17.8912 40.3256 17.3346V12.0666C40.3256 9.32434 39.3978 8.39648 36.7173 8.39648C35.7894 8.39648 34.9648 8.49956 34.14 8.69553C33.3152 8.89135 32.9029 9.03563 31.9751 9.52016'
                      fill='#002E83'
                    />
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M46.2019 19.2736V11.9953C46.9235 11.3251 47.439 11.0674 48.1607 11.0674C48.8822 11.0674 49.0884 11.3767 49.0884 12.4695V19.2736H52.2843V11.9539C52.2843 10.4488 52.0781 9.79934 51.6658 9.23241C51.1503 8.67566 50.5318 8.41797 49.6039 8.41797C48.3669 8.41797 47.439 8.87148 45.9958 10.1189V9.54164C45.9958 8.87148 45.6864 8.54157 45.0679 8.54157H41.9751V9.7066H42.0782C42.6968 9.7066 43.006 9.96429 43.006 10.5519V19.2736'
                      fill='#002E83'
                    />
                    <path
                      d='M62.1824 17.22H57.4402L61.9762 10.7457V8.53953H55.1721C54.3474 8.53953 54.0381 8.86945 54.0381 9.66326V11.6117H55.1721V11.3952C55.1721 10.8076 55.4814 10.5705 56.1 10.5705H58.5742L53.9351 17.0447V19.2715H62.1824'
                      fill='#002E83'
                    />
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M80.4296 18.6835V6.53922C80.4296 5.55984 80.0173 5.24025 79.0895 5.24025H76.3059V6.5805H76.6153C77.1307 6.5805 77.3369 6.77633 77.3369 7.37427V18.6835H80.4296ZM82.0791 18.6835H85.0688V9.51861C85.0688 8.59077 84.6565 8.21963 83.7287 8.21963H82.0791V18.6835ZM75.6874 18.6835V8.21963H74.038C73.1101 8.21963 72.6977 8.59077 72.6977 9.51861V18.6835H75.6874ZM88.5739 12.5805C88.5739 18.2609 84.4502 22.4052 78.8832 22.4052C73.3163 22.4052 69.1925 18.2609 69.1925 12.5805C69.1925 6.90009 73.3163 2.75575 78.8832 2.75575C84.4502 2.75575 88.5739 6.90009 88.5739 12.5805ZM90.5327 12.5805C90.5327 5.93102 85.5842 0.941309 78.8832 0.941309C72.2853 0.941309 67.2339 5.93102 67.2339 12.5805C67.2339 19.2506 72.2853 24.2402 78.8832 24.2402C85.5842 24.2402 90.5327 19.2506 90.5327 12.5805Z'
                      fill='#002E83'
                    />
                  </g>
                </svg>
                <Spacer />
                <p className='big-num neutral-text lh14 fw700'>
                  $4.9 <br className='hide mob-show' /> million
                </p>
              </div>
              <p className='grey-text fs16 mb30' style={{ lineHeight: '150%' }}>
                the average cost of a data breach worldwide in 2024.
              </p>
              <Spacer />
              <Divider style={{ marginTop: 0, marginBottom: 20 }} />
              <p className='grey-text fs16 ' style={{ lineHeight: '150%' }}>
                Allianz Cyber Security Resilience 2024
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className='light pt100 pb80 mob-pt-60 mob-pb-70'>
        <div className='container column column-center'>
          <h2 className='text-center mb45'>Strengthen your Security Culture with minimal effort</h2>

          <div className='row mob-column mb30' style={{ gap: 28 }}>
            <div className='white-box mob-pad-28-27 mob-radius-30 mob-pad-28-27 column mob-column-reverse'>
              <div className='column'>
                <p className='fs28 mb20 lh14 fw500 mob-fs-18 ptsans'>Unlock 200+ powerful training</p>
                <p className='dark-grey-text lh15 mob-fs-18 mob-fw-300 mb20 fs18 mob-mb-0 '>
                  Access our full library of 200+ training modules with 1 minute videos and interactive quizzes.
                </p>
              </div>
              <div className='column column-center'>
                <img className='mob-mb-14 mob-img-165 img-290' src='/images/gr2.png' alt='' />
              </div>
            </div>
            <div className='white-box mob-pad-28-27 mob-radius-30 mob-pad-28-27 column mob-column-reverse'>
              <div className='column'>
                <p className='fs28 mb20 lh14 fw500 mob-fs-18 ptsans'>Meet 24/7 Security Coach</p>
                <p className='dark-grey-text lh15 mob-fs-18 mob-fw-300 mb40 fs18 mob-mb-0 '>
                  Launch training in minutes with our Copilot that works seamlessly with Teams, Slack, and Google Chat.
                </p>
              </div>
              <img className='mob-mb-14' style={{ width: '100%', maxWidth: '604px' }} src='/images/gr3.png' alt='' />
            </div>
          </div>

          <div
            className='white-box mob-pad-28-27 mob-radius-30 mob-pad-28-27 row row-center mb30 mob-column-reverse pt0pb0'
            style={{ gap: 60 }}
          >
            <div className='column'>
              <p className='fs28 mb20 lh14 fw500 mob-fs-18 ptsans'>Train employees to detect Phishing</p>
              <p className='dark-grey-text lh15 mob-fs-18 mob-fw-300 mb50 fs18'>
                Empower your employees to recognise and stop advanced phishing attacks with user-adaptive simulation.
              </p>
            </div>
            <img style={{ width: '100%', maxWidth: 500 }} src='/images/gr21.png' alt='' />
          </div>

          <div className='white-box mob-pad-28-27 mob-radius-30 mob-pad-28-27 column column-center'>
            <h2 className='mb30 mob-fs-24'>Unlimited protection</h2>

            {loc == 'uk' && (
              <p className='fs24 mb20 mob-fs-20 text-center'>
                All features for <span className='fw700'>£1188 + VAT per annum</span>, the equivalent of just{' '}
                <span className='fw700'>£99 + VAT per month</span>.
              </p>
            )}
            {loc == 'us' && (
              <p className='fs24 mb20 mob-fs-20 text-center'>
                All features for <span className='fw700'>5000 USD + Local Tax per annum</span>, the equivalent of just{' '}
                <span className='fw700'>417 USD + Local Tax per month</span>.
              </p>
            )}
            {loc == 'eu' && (
              <p className='fs24 mb20 mob-fs-20 text-center'>
                All features for <span className='fw700'> €1,500 + VAT per annum</span>, the equivalent of just{' '}
                <span className='fw700'>€125 + VAT per month</span>.
              </p>
            )}
            {loc == 'aus' && (
              <p className='fs24 mb20 mob-fs-20 text-center'>
                All features for <span className='fw700'>A$2600 + GST per annum</span>, the equivalent of just{' '}
                <span className='fw700'>A$216.66 + GST per month</span>.
              </p>
            )}

            <p className='text-center mb40 fs22 lh12 mob-fs-16' style={{ color: '#4A4A4A' }}>
              This pricing applies to companies with up to 400 employees. For organizations exceeding this size, a
              tailored and competitively priced offer is available upon request.
            </p>

            <Button
              onClick={() => navigate('/online/' + loc + '/registration')}
              className='mb60'
              variant='contained'
              sx={{
                paddingX: '60px',
                fontSize: window.innerWidth < 768 ? '16px' : '22px'
              }}
            >
              Get started now
              <svg
                style={{ marginLeft: 30 }}
                width='10'
                height='14'
                viewBox='0 0 10 14'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M5.92375 7.00014L0.743408 1.88021L2.3385 0.303711L9.11394 7.00014L2.3385 13.6966L0.743408 12.1201L5.92375 7.00014Z'
                  fill='white'
                />
              </svg>
            </Button>

            <div className='column' style={{ maxWidth: 750 }}>
              <div className='row mb30'>
                <StarsListMarker />
                <p className='fs22 mob-fs-13 ptsans lh12'>
                  <span className='fw700 ptsans'>Easy subscription:</span> No hidden fees
                </p>
              </div>
              <div className='row mb30'>
                <StarsListMarker />
                <p className='fs22 mob-fs-13 ptsans lh12'>
                  <span className='fw700 ptsans'>Engaging platform:</span> Employees stay focused and prevent breaches.
                </p>
              </div>
              <div className='row mb30'>
                <StarsListMarker />
                <p className='fs22 mob-fs-13 ptsans lh12'>
                  <span className='fw700 ptsans'>Quick setup:</span> Launch training in less than{' '}
                  <strong>5 minutes</strong>.
                </p>
              </div>
              <div className='row mb30'>
                <StarsListMarker />
                <p className='fs22 mob-fs-13 ptsans lh12'>
                  <span className='fw700 ptsans'>Proven results:</span> Trusted by leading businesses.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='white pt90 pb100'>
        <div className='container1020 column column-center'>
          <h2 className='fs60 fw700 mb80'>FAQ</h2>

          <div className='column' style={{ width: '100%' }}>
            <div className='row row-center' onClick={() => setSelectedFaq(1)} style={{ cursor: 'pointer' }}>
              <p
                className='fs28 mob-fs-16 mob-fw-700 mob-lh-14'
                style={{ fontFamily: 'Roboto Slab', color: '#444444' }}
              >
                How to create an account and start using the platform?
              </p>
              <Spacer />
              <div style={{ marginLeft: 8, transform: selectedFaq == 1 && 'rotate(180deg)' }}>
                <svg width='20' height='11' viewBox='0 0 20 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M1.62451 1.30029L10.0245 9.70029L18.7745 1.30029'
                    stroke='#444444'
                    strokeWidth='2.4'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
            </div>
            <Collapse in={selectedFaq == 1}>
              <div
                style={{
                  padding: '20px 0px',
                  maxWidth: 800
                }}
              >
                <p className='lh14'>
                  Users can create an account through the registration button provided. After completing registration,
                  an activation email will be sent with instructions to access the platform and start the training. The
                  platform is ready to use immediately after account creation — no integrations are required. However,
                  for organisations seeking automation and easier management, integration options are available,
                  including: <br />
                  <br />- Single Sign-On (SSO) with Microsoft Azure AD, Okta, Google Workspace, and others
                  <br />- User synchronisation via SCIM or directory connectors
                  <br />- Integration with Microsoft Teams, Slack, and email platforms for in-app training and phishing
                  simulations
                  <br />- API access for advanced customisation if needed
                </p>
                <br />
                <p>
                  Basic setup can be completed in just a few steps, and optional integrations can be added anytime based
                  on organisational needs.
                </p>
              </div>
            </Collapse>
            <Divider />
          </div>

          <div className='column' style={{ width: '100%' }}>
            <div className='row row-center' onClick={() => setSelectedFaq(2)} style={{ cursor: 'pointer' }}>
              <p
                className='fs28 mob-fs-16 mob-fw-700 mob-lh-14'
                style={{ fontFamily: 'Roboto Slab', color: '#444444' }}
              >
                What security topics are covered in the awareness training?
              </p>
              <Spacer />
              <div style={{ marginLeft: 8, transform: selectedFaq == 2 && 'rotate(180deg)' }}>
                <svg width='20' height='11' viewBox='0 0 20 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M1.62451 1.30029L10.0245 9.70029L18.7745 1.30029'
                    stroke='#444444'
                    strokeWidth='2.4'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
            </div>
            <Collapse in={selectedFaq == 2}>
              <div
                style={{
                  padding: '20px 0px',
                  maxWidth: 800
                }}
              >
                <p className='lh14'>
                  The training covers essential cybersecurity topics such as phishing prevention, password security,
                  safe internet usage, data protection, secure remote work, and recognising social engineering tactics.{' '}
                  <br />
                  <br />
                  The platform also supports compliance training aligned with ISO 27001, GDPR, HIPAA, PCI DSS, NIS2, and
                  SOC 2 standards, helping organisations meet regulatory and certification requirements. New topics are
                  continuously added to address emerging security threats.
                </p>
              </div>
            </Collapse>
            <Divider />
          </div>

          <div className='column' style={{ width: '100%' }}>
            <div className='row row-center' onClick={() => setSelectedFaq(3)} style={{ cursor: 'pointer' }}>
              <p
                className='fs28 mob-fs-16 mob-fw-700 mob-lh-14'
                style={{ fontFamily: 'Roboto Slab', color: '#444444' }}
              >
                How can I track the progress of my team?
              </p>
              <Spacer />
              <div style={{ marginLeft: 8, transform: selectedFaq == 3 && 'rotate(180deg)' }}>
                <svg width='20' height='11' viewBox='0 0 20 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M1.62451 1.30029L10.0245 9.70029L18.7745 1.30029'
                    stroke='#444444'
                    strokeWidth='2.4'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
            </div>
            <Collapse in={selectedFaq == 3}>
              <div
                style={{
                  padding: '20px 0px',
                  maxWidth: 800
                }}
              >
                <p className='lh14'>
                  A dedicated dashboard allows administrators to monitor both individual and team progress, view
                  training completion rates, assess phishing simulation results, and generate detailed reports to track
                  improvements and manage human risk effectively.
                </p>
              </div>
            </Collapse>
            <Divider />
          </div>

          <div className='column' style={{ width: '100%' }}>
            <div className='row row-center' onClick={() => setSelectedFaq(4)} style={{ cursor: 'pointer' }}>
              <p
                className='fs28 mob-fs-16 mob-fw-700 mob-lh-14'
                style={{ fontFamily: 'Roboto Slab', color: '#444444' }}
              >
                What are the top reasons organisations choose this platform?
              </p>
              <Spacer />
              <div style={{ marginLeft: 8, transform: selectedFaq == 4 && 'rotate(180deg)' }}>
                <svg width='20' height='11' viewBox='0 0 20 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M1.62451 1.30029L10.0245 9.70029L18.7745 1.30029'
                    stroke='#444444'
                    strokeWidth='2.4'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
            </div>
            <Collapse in={selectedFaq == 4}>
              <div
                style={{
                  padding: '20px 0px',
                  maxWidth: 800
                }}
              >
                <p className='lh14'>
                  Organisations value the platform for its personalised learning paths, engaging gamified approach,
                  broad coverage of cybersecurity and compliance topics, real-time reporting and risk management
                  insights, and seamless integration with tools such as Microsoft Teams, Outlook, and Slack.
                </p>
              </div>
            </Collapse>
            <Divider />
          </div>

          <div className='column' style={{ width: '100%' }}>
            <div className='row row-center' onClick={() => setSelectedFaq(5)} style={{ cursor: 'pointer' }}>
              <p
                className='fs28 mob-fs-16 mob-fw-700 mob-lh-14'
                style={{ fontFamily: 'Roboto Slab', color: '#444444' }}
              >
                How does gamified security awareness training work for your employees?
              </p>
              <Spacer />
              <div style={{ marginLeft: 8, transform: selectedFaq == 5 && 'rotate(180deg)' }}>
                <svg width='20' height='11' viewBox='0 0 20 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M1.62451 1.30029L10.0245 9.70029L18.7745 1.30029'
                    stroke='#444444'
                    strokeWidth='2.4'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
            </div>
            <Collapse in={selectedFaq == 5}>
              <div
                style={{
                  padding: '20px 0px',
                  maxWidth: 800
                }}
              >
                <p className='lh14'>
                  Gamified training uses points, badges, challenges, and leaderboards to make learning interactive and
                  motivating. Employees are encouraged to actively participate, complete learning activities, and
                  strengthen their cybersecurity habits through an engaging and competitive experience.
                </p>
              </div>
            </Collapse>
            <Divider />
          </div>
        </div>
      </section>

      <FooterSpecial theme={THEMES.dark} />
    </div>
  )
}
